import { motion, AnimatePresence } from 'framer-motion';
import { X, Heart } from 'lucide-react';

const FounderNoteModal = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          onClick={onClose}
          data-testid="founder-note-modal"
        >
          <motion.div
            initial={{ scale: 0.85, y: 40, rotate: -2 }}
            animate={{ scale: 1, y: 0, rotate: 0 }}
            exit={{ scale: 0.9, y: 20, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 200, damping: 20 }}
            className="relative max-w-2xl w-full bg-[#F5EFDC] text-black p-8 sm:p-12 border-4 border-black"
            style={{ boxShadow: '12px 12px 0px #FF3D00' }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={onClose}
              data-testid="founder-note-close"
              data-cursor="CLOSE"
              className="absolute top-4 right-4 bg-black text-[#FF3D00] p-2 hover:bg-[#FF3D00] hover:text-black transition-colors"
            >
              <X size={18} />
            </button>

            <div className="inline-block bg-[#FF3D00] text-black px-3 py-1 font-['Outfit'] font-bold uppercase text-xs tracking-[0.2em] mb-6 -rotate-2">
              You found it
            </div>

            <h2 className="font-['Bebas_Neue'] text-4xl sm:text-5xl uppercase leading-none mb-6">
              A note from <br /><span className="text-[#FF3D00]">the founder.</span>
            </h2>

            <div className="space-y-4 font-['Manrope'] text-base sm:text-lg text-black/80 leading-relaxed">
              <p>
                Hey — if you clicked the logo five times, you're <em>exactly</em> the kind of person we built this for.
              </p>
              <p>
                I grew up eating cream biscuits. Tons of them. Like an embarrassing amount. One day, somewhere between adulthood and reading a nutrition label, it hit me: <strong>the thing I love most is also the worst possible thing I could be putting in my body.</strong>
              </p>
              <p>
                I looked everywhere for a better version. Found a few "protein cookies" that taste like sawdust. Found a few "healthy biscuits" that lied on the label. Nothing actually scratched the itch.
              </p>
              <p>
                So we're making it ourselves. Slowly. Honestly. We're not pretending we have it all figured out — we're literally building it in public on @go.waybig. The pack you saw on the homepage? That's V1. It'll get better.
              </p>
              <p>
                If you're here, you care. Thanks for caring. We'll do this right.
              </p>
              <p className="pt-2 font-['Bebas_Neue'] text-2xl flex items-center gap-2">
                — Team Way Big <Heart className="text-[#FF3D00] fill-[#FF3D00]" size={20} />
              </p>
            </div>

            <div className="mt-8 pt-6 border-t-2 border-black/20">
              <p className="font-['Outfit'] text-xs uppercase tracking-[0.2em] text-black/60">
                P.S. — don't tell anyone about the logo trick.
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FounderNoteModal;
